module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#comment",
      toString: function () {
        return this.url;
      }
    }